import { BetterErrors } from "@better-errors/client"
import { IS_PRODUCTION } from "./env"

export const be = new BetterErrors("https://better-errors.com/c/27b83b24-2f87-4e22-a61e-94fc594ac297", {
  // isEnabled: false,
  isEnabled: IS_PRODUCTION,
})
